var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2225,
    height: 3,
    viewBox: "0 0 2225 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5L2223 1.49981",
    stroke: "#BFC8D9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "70 70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLine);
export default __webpack_public_path__ + "static/media/dashLine.6e2cb68a2bce3949d77618a826cb92fa.svg";
export { ForwardRef as ReactComponent };